import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CONCESSIONARIAS_EMAIL_KEY, CONCESSIONARIAS_EMAIL_SENT_KEY} from '@shared/constants/storage-keys';
import {NgOptimizedImage} from '@angular/common';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';

import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {DialogModule} from 'primeng/dialog';
import {MessageService} from 'primeng/api';
import {IconEntrarLogin} from "../../../../components/icons/icon-entrar-login/icon-entrar-login.component";
import {AuthService} from '../../../../core/services/auth.service';
import {finalize} from 'rxjs';
import {Toast} from 'primeng/toast';
import {Router} from '@angular/router';

@Component({
    selector: 'app-token-email',
    standalone: true,
    imports: [
        FormsModule,
        ButtonModule,
        CardModule,
        DialogModule,
        IconEntrarLogin,
        Toast,
        NgOptimizedImage,
        ReactiveFormsModule
    ],
    providers: [MessageService],
    templateUrl: './token-email.component.html',
    styleUrl: './token-email.component.css'
})
export class TokenEmailComponent implements OnInit {

    @Input() email: string = '';
    loading: boolean = false;
    tokenCtrl = new FormControl('', [Validators.required]);
    @Output() requestNewTokenEvent = new EventEmitter<void>();

    constructor(
        private readonly authService: AuthService,
        private readonly messageService: MessageService,
        private readonly router: Router
    ) {
    }

    ngOnInit(): void {
        if (!this.email) {
            const storedEmail = sessionStorage.getItem(CONCESSIONARIAS_EMAIL_KEY);
            if (storedEmail) {
                this.email = storedEmail;
            }
        }
        this.tokenCtrl.reset();
    }


    verifyToken() {
        if (this.tokenCtrl.invalid) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Token inválido',
                detail: 'Por favor, digite o token.'
            })
            return;
        }

        const token = this.tokenCtrl.value || '';

        this.authService
            .loginWithConcessionaria(this.email, token)
            .pipe(
                finalize(() => this.loading = false)
            ).subscribe({
            error: (err) => {
                console.log('erro ao verificar token de acesso: ', err.error)
                this.messageService.add({
                    severity: 'error',
                    summary: 'Token inválido',
                    detail: 'O token inserido é inválido. Clique em "Enviar Token Novamente"',
                });
            }
        });
    }

    onRequestNewToken() {
        sessionStorage.removeItem(CONCESSIONARIAS_EMAIL_SENT_KEY);
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.router.navigate(['/auth/login-concessionarias']).then();
        });
    }


}
